import React from "react";
import "./Aims.css"; // Import the CSS file for styling

const Aims = () => {
  return (
    <div className="text-page">
      <header className="header">
        <h1 className="SubTitle">What our Aims are</h1>
      </header>
      <main className="content">
        <section className="text-section">
          <h2>The LESTO Objective</h2>
          <p>
            Shortening the time-to market of the LFR technology is an ambitious,
            but undeniably important factor to attract additional investments,
            thanks to the lower initial risk, added flexibility, and faster
            return of experience. Industries and utilities sharing the vision of
            a competitive LFR of a small and medium-size with modular features
            will be attracted by the compressed deployment roadmap, and will
            play a leverage role at national and European level, strengthening
            synergies and creating public–private–partnership opportunities. In
            this context, the European community working on the LFR development
            and deployment assumed the commitment, among others, to highlight
            the technical open issues and existing research infrastructures,
            aiming to support the R&D phase through European, national and
            in-kind contribution of the involved partners.<br></br>
            <br></br> The aim of the LESTO project is moving on along the
            depicted roadmap, aiming at further developing the LFR technology,
            supporting the demonstration that LFRs can be designed, sited,
            constructed, commissioned and operated in line with the requirements
            of the actual safety standards, with particular focus on their
            safety features and passive safety systems. Along the project the
            most relevant facilities in Europe and UK will be adopted to
            implement a large and very comprehensive experimental database for
            code validation, safety assessment and component/system
            demonstration. <br></br>
            <br></br>Among the others, it is worth to mention the large-scale
            pool type ATHENA facility, being commissioned in Romania, the CIRCE
            pool in Italy, as well as MELECOR in UK. These facilities, with the
            support of research infrastructure in Belgium, Germany and Sweden
            represent the state of art for the LFR R&D. Large emphasis will be
            devoted to transient analysis in large pools, allowing the community
            to cross the death valley from laboratory to industry scale.
          </p>
        </section>
      </main>
    </div>
  );
};

export default Aims;
